import { useEffect, useState } from "react";

function Countdown({ target }) {
  const [timeLeft, setTimeLeft] = useState(() => {
    const diff = new Date(target) - new Date();
    return diff > 0 ? diff : 0;
  });

  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      const diff = new Date(target) - new Date();
      setTimeLeft(diff > 0 ? diff : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [target, timeLeft]);

  // ⛔ Don't render if time is over
  if (timeLeft <= 0) return null;

  const oneDayMs = 1000 * 60 * 60 * 24;

  // 🕒 Show TIMER if less than 1 day
  if (timeLeft < oneDayMs) {
    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    return (
      <div className="p-[2px] bg-[linear-gradient(93.84deg,#EA5133_0%,#5744B1_100%)] inline-block rounded-xl mr-4">
        <div className="pt-2 pb-2 pl-6 pr-6 bg-[#140F30] rounded-xl text-center">
          <p className="text-2xl font-bold text-white">
            {String(hours).padStart(2, "0")}:
            {String(minutes).padStart(2, "0")}:
            {String(seconds).padStart(2, "0")}
          </p>
          <p className="text-xs text-white">Time to go</p>
        </div>
      </div>
    );
  }

  // 📅 Show DAYS if ≥ 1 day
  const daysRemaining = Math.ceil(timeLeft / oneDayMs);

  return (
    <div className="p-[2px] bg-[linear-gradient(93.84deg,#EA5133_0%,#5744B1_100%)] inline-block rounded-xl mr-4">
      <div className="pt-2 pb-2 pl-6 pr-6 bg-[#140F30] rounded-xl text-center">
        <p className="text-3xl font-bold text-white">{daysRemaining}</p>
        <p className="text-xs text-white">Day</p>
        <p className="text-xs text-white">To go</p>
      </div>
    </div>
  );
}

export default Countdown;
